import React, { useState } from 'react';
import { connect } from 'react-redux';
import DirectionsList from './DirectionsList';
import DirectionsList_All from './DirectionsList_All';
import withLoading from '../shared/withLoading';
import { IconAlert } from '../Icons';
import TripWarnings from './TripWarnings';


const Directions = props => {
    const {trips, error, currentTrip} = props;
    const [update, setUpdate] = useState(true);
    const [buttonText, setButtonText] = useState('Show More Results');
    const changeText = (text) => setButtonText(text);
    
    if (!error && trips.length === 0) {
        return <div></div>;
    }
    if (!error && trips.length <= 1) {
        return <div>
            <div className="otp-directions">
                <h2>Here is the best trip option for you:</h2>
                <TripWarnings trips={trips} />
                <div className="otp-directions-list">
                    <DirectionsList
                        trips={trips}
                        currentTrip={currentTrip}
                    />
                </div>
            </div>
        </div>;
    }
    if (!error && trips.length <= 3) {
        return <div>
            <div className="otp-directions">
                <h2>Here are the best trips for you:</h2>
                <TripWarnings trips={trips} />
                <div className="otp-directions-list">
                    <DirectionsList
                        trips={trips}
                        currentTrip={currentTrip}
                    />
                </div>
            </div>
        </div>;
    }
    if (error) {
        return(
            <div className="otp-directions otp-has-error">
                <h2>We were unable to plan your trip.</h2>
                <div className="otp-error">
                    <IconAlert /> {error.msg}
                </div>
            </div>
        );
    }

    return(
        <div className="otp-directions">
            <h2>Here are the best trips for you:</h2>
            <TripWarnings trips={trips} />
            <div className="otp-directions-list">
                { update
                    ? <DirectionsList
                        trips={trips}
                        currentTrip={currentTrip} />
                    : <DirectionsList_All
                        trips={trips}
                        currentTrip={currentTrip} />
                }       
            </div>
            <div className="otp-button-primary otp-edit-button">
                <button onClick ={() => {setUpdate(false); changeText('All Results Are Showing');}}>
                    {buttonText}
                </button>
                <br/>
            </div>
        </div>
    );
};


const mapStateToProps = state => {
    return {
        ...state.directions,
    };
};




const WrappedDirections = withLoading({text:'Loading Directions...'})(Directions);
export default connect(mapStateToProps)(WrappedDirections);